import React from 'react'
import ReactSwipe from 'react-swipe'

export default class SliderContainer extends React.Component {
  constructor(props) {
    super(props)
    this.slider = React.createRef()
    this.state = {
      currentSlide: 0,
      sliding: false,
      atTitle: 0
    }
  }

  moveRight = () => {
    //  this.slider.current.next()
  }

  // ReactSwipe Slider options
  swipeOptions = {
    speed: 1000,
    startSlide: 0,
    continuous: this.props.continues,
    auto: this.props.continues ? 7000 : 0,
    callback: index => {
      this.setState({
        currentSlide: index,
        sliding: true
      })
    },
    transitionEnd: index => {
      this.setState({
        atTitle: index,
        sliding: false
      })
    }
  }

  render() {
    const { content } = this.props

    const sliderItems = content.map((a, i) => (
      <div
        className="panel"
        style={{ backgroundImage: `url(${a.image.sizes.hd})` }}
        key={i}
      />
    ))
    return (
      <div className="slider">
        <div
          className={`title-box ${this.props.position} ${
            this.state.sliding ? 'sliding' : ''
          } ${this.props.padding ? 'padding' : ''}`}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: content[this.state.atTitle].content
                ? content[this.state.atTitle].content
                : ''
            }}
          />
          <div className="controls">
            {content.map((a, i) => (
              <span
                key={i}
                className={`${this.state.currentSlide === i ? 'current' : ''}`}
                onClick={e => {
                  e.stopPropagation()
                  this.slider.current.slide(i, this.swipeOptions.speed)
                }}
              />
            ))}
          </div>
        </div>
        <ReactSwipe
          ref={this.slider}
          className="carousel"
          swipeOptions={this.swipeOptions}
        >
          {sliderItems}
        </ReactSwipe>
      </div>
    )
  }
}
